export default __webpack_public_path__ + "static/media/jquery.14cbc7ce.png";